import React, { useState } from 'react';
import { Img } from 'react-image';
import Box from '@material-ui/core/Box';

import { StyledOutlineButton } from '../../../components/button/Button';
import logoThaID from '../../../assets/images/logo-thaid.png';
import FormControl from '@material-ui/core/FormControl';
const ThaidRedirect = () => {
  const [error, setError] = useState(null);

  const toUrlThaID = async () => {
    try {
      const redirectUrl = `${process.env.REACT_APP_BACKOFFICE}/backoffice/thaid/login/ntw`;
      window.location.href = redirectUrl;
    } catch (err) {
      setError('Failed to initiate OAuth flow');
    }
  };

  if (error) {
    return <div className="error-message">Error: {error}</div>;
  }

  return (
    <div>
      <Box display="flex" alignItems="center" justifyContent="center" my={4} style={{ width: '100%' }}>
        <hr style={{ border: '0.5px solid #ccc', width: '100%'}} />
        <span className="h6" style={{ paddingLeft: 10, background: '#fff',  width: '100%', whiteSpace: 'nowrap', paddingRight: 10 }}>เข้าสู่ระบบด้วย Digital ID</span>
        <hr style={{ border: '0.5px solid #ccc', width: '100%'}} />
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <FormControl id="login-button" style={{ width: '80%', marginTop: 20 }} onClick={toUrlThaID}>
          <StyledOutlineButton type="submit" variant="outlined">
              <Img src={logoThaID} alt="แอปพลิเคชัน ThaID" width={30} />
              <span className="h6" style={{ paddingLeft: 10, textTransform: 'Capitalize' }}>แอปพลิเคชัน ThaID</span>
          </StyledOutlineButton>
        </FormControl>
      </Box>
    </div>
  );
};

export default ThaidRedirect;
